export const NotFoundPageTranslationsEn = {
  'Page not found': 'Page not found',
  'Problem explanation':
    'Sorry, we couldn`t find the page you`re looking for. Please try again.',
  Homepage: 'Homepage',
};
